import { handleRequest } from "../utilities/requestHandler";

export const getLineDiscounts = () =>
	handleRequest("get", "/line-discounts");

export const searchLineDiscountProducts = ({ search = "", ids = [] } = {}) => {
	const params = new URLSearchParams();
	if (String(search || "").trim()) params.set("search", String(search).trim());
	if (Array.isArray(ids) && ids.length) params.set("ids", ids.join(","));
	const query = params.toString();
	return handleRequest("get", `/line-discounts/products${query ? `?${query}` : ""}`);
};

export const createLineDiscount = (payload) =>
	handleRequest("post", "/line-discounts", payload);

export const updateLineDiscount = (id, payload) =>
	handleRequest("put", `/line-discounts/${id}`, payload);

export const deactivateLineDiscount = (id) =>
	handleRequest("delete", `/line-discounts/${id}`);

export const resolveLineDiscounts = (payload) =>
	handleRequest("post", "/line-discounts/resolve", payload);
